import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  branches: {
    id: 'frontbucket.repository.branch.breadcrumbs.branches',
    description: 'Text to display on branches breadcrumbs',
    defaultMessage: 'Branches',
  },
  checkoutBranch: {
    id: 'frontbucket.repository.branch.empty.checkoutBranch',
    description: 'Text for suggesting to check out a branch',
    defaultMessage: 'Check out your branch',
  },
  checkoutBranchHelpText: {
    id: 'frontbucket.repository.branch.empty.checkoutBranchHelpText',
    description: 'Help text for suggesting to check out a branch',
    defaultMessage:
      'This branch does not contain any changes — check it out on your local machine to do some work.',
  },
  source: {
    id: 'frontbucket.repository.branch.headerActions.source',
    description: 'Text to display on View Source Button',
    defaultMessage: 'View source',
  },
  merge: {
    id: 'frontbucket.repository.branch.headerActions.merge',
    description: 'Text to display on Merge Button',
    defaultMessage: 'Merge',
  },
  delete: {
    id: 'frontbucket.repository.branch.headerActions.delete',
    description: 'Text to display on delete Button',
    defaultMessage: 'Delete branch',
  },
  createPR: {
    id: 'frontbucket.repository.branch.headerActions.createPR',
    description: 'Text to display on create PR Button',
    defaultMessage: 'Create pull request',
  },
  compare: {
    id: 'frontbucket.repository.branch.compareWidget.compare',
    description: 'Selector for comparing branches',
    defaultMessage: 'Compare',
  },
  mergeConflict: {
    id: 'frontbucket.repository.branch.headerActions.mergeConflict',
    description: 'Text of tooltip',
    defaultMessage: 'You will need to resolve conflicts to be able to merge.',
  },
  pullRequestExists: {
    id: 'frontbucket.repository.branch.headerActions.createPr.prExists',
    description: 'Text of tooltip on create PR button',
    defaultMessage:
      'A pull request with the selected source and destination branches already exists.',
  },
  branch: {
    id: 'frontbucket.repository.branch.title.branch',
    description: 'The word Branch for the title of the html page',
    defaultMessage: 'Branch',
  },
});
